export const translations = {
  en: {
    nav_home: "Home",
    nav_apps: "Space Apps",
    nav_labs: "Science Labs",
    nav_about: "About",
    nav_admin: "Admin",
    hero_badge: "ESSS Science & Innovation",
    hero_title: "Ethiopian Space Science Society",
    hero_subtitle: "Exploration, Innovation, and Inspiration for Africa's Space Future.",
    hero_cta: "Explore the Universe",
    hero_secondary: "View Space Apps",
    featured_tag: "Space Application",
    featured_title_main: "Walk in the Solar System",
    status_active: "Space App",
    featured_title: "Walk in the Solar System",
    featured_desc: "Experience our neighborhood in space with this interactive 3D map. Explore accurate orbital mechanics, scaled celestial bodies, and immersive physics-based simulation.",
    features_title: "Key Features:",
    feat_1: "Interactive 3D celestial navigation",
    feat_2: "Accurate orbital mechanics & scaling",
    feat_3: "Bilingual guidance & rich educational details",
    featured_button: "Launch Interactive Map",
    lunar_tag: "Space Application",
    lunar_title_main: "3D Interactive Lunar Explorer",
    status_active_lunar: "Space App",
    lunar_title: "Lunar Explorer & Topography",
    lunar_desc: "Explore the Moon in full 3D. Inspect historic landing sites, craters, and maria using high-resolution NASA topology data mapped to a realistic spherical globe.",
    lunar_features_title: "Key Features:",
    lunar_feat_1: "High-resolution 3D terrain",
    lunar_feat_2: "50+ annotated historic locations",
    lunar_feat_3: "Offline-ready bilingual encyclopedia",
    lunar_button: "Launch Lunar Explorer",
    eclipse_tag: "Space Application",
    eclipse_title_main: "Solar & Lunar Eclipse Predictor",
    status_active_eclipse: "Space App",
    eclipse_title: "Solar & Lunar Eclipse Predictor",
    eclipse_desc: "Explore past and future solar and lunar eclipses. Inspect totality paths, penumbral coverage, and local obscuration details using our high-precision simulation engine.",
    eclipse_features_title: "Key Features:",
    eclipse_feat_1: "Precision 2D/3D dynamic map views",
    eclipse_feat_2: "Custom local simulation & stats",
    eclipse_feat_3: "Kotlin integration & offline support",
    eclipse_button: "Launch Eclipse Predictor",
    future_tag: "Science Labs",
    future_title: "Science Lab Modules",
    future_subtitle: "Explore our collection of interactive science labs, physics sandboxes, and aerospace simulators.",
    coming_soon: "Coming Soon",
    project_sat_title: "Ethiopian Satellite Tracker",
    project_sat_desc: "Real-time tracking of ET-RSS1 and future Ethiopian spacecraft with orbital path visualization.",
    project_exo_title: "Exoplanet Archive",
    project_exo_desc: "Searchable index of discovered exoplanets with 3D transit visualization models.",
    project_weather_title: "Space Weather Observatory",
    project_weather_desc: "Live monitoring of solar flares, geomagnetic storms, and ionospheric perturbations over East Africa.",
    about_tag: "About the Society",
    about_title: "Ethiopian Space Science Society (ESSS)",
    about_desc: "Established in 2004, the Ethiopian Space Science Society (ESSS) is a non-governmental organization composed of members representing space science professionals, space technology enthusiasts, and interested individuals. ESSS operates with a mission to develop space science and technology capacity in Ethiopia, making the country an active contributor to space applications in East Africa.",
    stat_est: "Established",
    stat_members: "Active Members",
    stat_branches: "Regional Branches",
    footer_tagline: "Advancing astronomical sciences and space technology research in Ethiopia.",
    footer_links_title: "Quick Links",
    footer_main_site: "Official Website",
    footer_social_title: "Connect",
    
    // Scientific Modules & Categories
    in_development: "In Development",
    mod_btn_pending: "Pending",
    mod_btn_launch: "Launch Module",
    powered_by: "Powered by:",
    
    cat_planetary_science: "Planetary Science",
    cat_astrophysics: "Astrophysics",
    cat_cosmology___relativity: "Cosmology & Relativity",
    cat_astrobiology: "Astrobiology",
    cat_aerospace_engineering: "Aerospace Engineering",
    cat_space_weather___physics: "Space Weather & Physics",
    cat_radio_science: "Radio Science",
    cat_earth_observation___climate: "Earth Observation & Climate",
    
    comp_ultra: "Ultra",
    comp_high: "High",
    comp_medium: "Medium",
    comp_low: "Low",
    
    aud_all: "All",
    aud_students___teachers: "Students & Teachers",
    aud_students___enthusiasts: "Students & Enthusiasts",
    aud_enthusiasts___nerds: "Enthusiasts & Nerds",
    
    footer_copyright: "Ethiopian Space Science Society (ESSS). All rights reserved.",
    login_required: "Access Denied",
    login_required_desc: "This scientific simulation is restricted. Please sign in with your ESSS account to launch it.",
    login_btn: "Sign in with Google",
    logout_btn: "Sign Out",
  },
  am: {
    nav_home: "መነሻ ገጽ",
    nav_apps: "የስፔስ መተግበሪያዎች",
    nav_labs: "የሳይንስ ላብራቶሪዎች",
    nav_about: "ስለ እኛ",
    nav_admin: "አስተዳዳሪ",
    hero_badge: "የኢትዮጵያ ስፔስ ሳይንስና ፈጠራ",
    hero_title: "የኢትዮጵያ ስፔስ ሳይንስ ሶሳይቲ",
    hero_subtitle: "አሰሳ፣ ፈጠራ እና መነሳሳት ለአፍሪካ የጠፈር መፃኢ እድል ።",
    hero_cta: "ዩኒቨርስን ያስሱ",
    hero_secondary: "የስፔስ መተግበሪያዎችን ይመልከቱ",
    featured_tag: "የስፔስ መተግበሪያ",
    featured_title_main: "በስርዓተ ፀሐይ ውስጥ የሚደረግ ጉዞ",
    status_active: "የስፔስ መተግበሪያ",
    featured_title: "በስርዓተ ፀሐይ ውስጥ የሚደረግ ጉዞ",
    featured_desc: "በስርዓተ ፀሐይ ውስጥ የሚደረግ በይነተገናኝ 3-ዲ ጉዞ። ትክክለኛ የሰማይ አካላት ምህዋር፣ የተመጣጠነ መጠን እና ጥልቅ የስበት ማስመሰያዎችን ያስሱ።",
    features_title: "ዋና ዋና ባህሪያት፡",
    feat_1: "በይነተገናኝ የ3-ዲ ሰማይ አካላት አሰሳ",
    feat_2: "ትክክለኛ የሰውነት ምህዋር እና መጠን ማስተካካያ",
    feat_3: "ሁለት ቋንቋዎችን የሚደግፍና ሰፊ ትምህርታዊ መግለጫ",
    featured_button: "በይነተገናኙን ካርታ ክፈት",
    lunar_tag: "የስፔስ መተግበሪያ",
    lunar_title_main: "ባለ 3-ዲ በይነተገናኝ የጨረቃ ማሰሻ",
    status_active_lunar: "የስፔስ መተግበሪያ",
    lunar_title: "የጨረቃ ማሰሻ እና ገጽታ",
    lunar_desc: "ጨረቃን በ3-ዲ ያስሱ። ከፍተኛ ጥራት ያለው የናሳ መረጃን በመጠቀም ታሪካዊ የማረፊያ ቦታዎችን፣ ቆሬዎችን እና ሜዳዎችን በተጨባጭ ምናባዊ ሞዴል ይመልከቱ።",
    lunar_features_title: "ዋና ዋና ባህሪያት፡",
    lunar_feat_1: "ከፍተኛ ጥራት ያለው የ3-ዲ ገጽታ",
    lunar_feat_2: "ከ50 በላይ የተብራሩ ታሪካዊ ቦታዎች",
    lunar_feat_3: "ከመስመር ውጭ የሚሰራ ባለሁለት ቋንቋ መዝገበ-ዕውቀት",
    lunar_button: "የጨረቃ ማሰሻን ክፈት",
    eclipse_tag: "የስፔስ መተግበሪያ",
    eclipse_title_main: "የፀሐይና ጨረቃ ግርዶሽ መተንበያ",
    status_active_eclipse: "የስፔስ መተግበሪያ",
    eclipse_title: "የፀሐይና ጨረቃ ግርዶሽ መተንበያ",
    eclipse_desc: "ያለፉ እና የወደፊት የፀሐይ እና ጨረቃ ግርዶሾችን ያስሱ። ትክክለኛ የግርዶሽ መስመሮችን፣ የጥላ ስርጭትን እና የአካባቢውን መቶኛ በእኛ ከፍተኛ ጥራት ማስያ ይመልከቱ።",
    eclipse_features_title: "ዋና ዋና ባህሪያት፡",
    eclipse_feat_1: "ከፍተኛ ጥራት ያለው ባለ 2-ዲ እና 3-ዲ በይነተገናኝ እይታ",
    eclipse_feat_2: "የአካባቢ የግርዶሽ ማስያ እና ስታቲስቲክስ",
    eclipse_feat_3: "የኮትሊን ውህደት እና ከመስመር ውጭ ድጋፍ",
    eclipse_button: "የግርዶሽ መተንበያውን ክፈት",
    future_tag: "የሳይንስ ላብራቶሪዎች",
    future_title: "የሳይንስ ላብራቶሪ ሞጁሎች",
    future_subtitle: "በይነተገናኝ የሳይንስ ላብራቶሪዎችን፣ የፊዚክስ ማሳያዎችን እና የኤሮስፔስ ሲሙሌተሮችን ያስሱ።",
    coming_soon: "በቅርቡ የሚጠበቅ",
    project_sat_title: "የኢትዮጵያ ሳተላይት መከታተያ",
    project_sat_desc: "የኢትዮጵያ ሳተላይት ET-RSS1 እና የወደፊት መንኮራኩሮችን ትክክለኛ መገኛ እና የምህዋር መስመር መከታተያ።",
    project_exo_title: "የኤክሶፕላኔት መዝገብ",
    project_exo_desc: "የተገኙ የኤክሶፕላኔቶች ዝርዝር እና የፍለጋ መዝገብ ከባለ 3-ዲ እይታ ሞዴሎች ጋር።",
    project_weather_title: "የጠፈር አየር ሁኔታ መከታተያ",
    project_weather_desc: "የፀሐይ ነበልባሎች፣ የጂኦማግኔቲክ ማዕበሎች እና በምስራቅ አፍሪካ ላይ ያለውን የኤሌክትሮማግኔቲክ መለዋወጥ መከታተያ።",
    about_tag: "ስለ ሶሳይቲው",
    about_title: "የኢትዮጵያ ስፔስ ሳይንስ ሶሳይቲ (ኢስሳሶ)",
    about_desc: "በ2004 እ.ኤ.አ. የተመሰረተው የኢትዮጵያ ስፔስ ሳይንስ ሶሳይቲ (ESSS) የጠፈር ሳይንስ ባለሙያዎችን፣ የጠፈር ቴክኖሎጂ አፍቃሪዎችን እና ፍላጎት ያላቸውን ግለሰቦች ያቀፈ መንግስታዊ ያልሆነ ድርጅት ነው። ኢስሳሶ በኢትዮጵያ የጠፈር ሳይንስና ቴክኖሎጂ አቅምን ለማጎልበት እና ሀገሪቱን በምስራቅ አፍሪካ የጠፈር መተግበሪያዎች ላይ ንቁ ተሳትፎ እንድታደርግ ለማስቻል እየሰራ ይገኛል።",
    stat_est: "የተመሰረተበት",
    stat_members: "ንቁ አባላት",
    stat_branches: "ክልላዊ ቅርንጫፎች",
    footer_tagline: "በኢትዮጵያ ውስጥ የስነ-ኮከብ ሳይንስ እና የጠፈር ቴክኖሎጂ ምርምርን ማሳደግ።",
    footer_links_title: "ፈጣን አገናኞች",
    footer_main_site: "ዋናው ድረ-ገጽ",
    footer_social_title: "ይገናኙን",
    in_development: "በእቅድ ላይ ያሉ",
    mod_btn_pending: "በመሰራት ላይ",
    mod_btn_launch: "ሞጁሉን ክፈት",
    powered_by: "የተገነባው በ፡",
    cat_planetary_science: "የፕላኔቶች ሳይንስ",
    cat_astrophysics: "አስትሮፊዚክስ",
    cat_cosmology___relativity: "ኮስሞሎጂ እና አንጻራዊነት",
    cat_astrobiology: "አስትሮባዮሎጂ",
    cat_aerospace_engineering: "ኤሮስፔስ ኢንጂነሪንግ",
    cat_space_weather___physics: "የጠፈር አየር ሁኔታ እና ፊዚክስ",
    cat_radio_science: "የሬዲዮ ሳይንስ",
    cat_earth_observation___climate: "የመሬት ምልከታ እና የአየር ንብረት",
    comp_ultra: "እጅግ ከፍተኛ",
    comp_high: "ከፍተኛ",
    comp_medium: "መካከለኛ",
    comp_low: "ቀላል",
    aud_all: "ለሁሉም",
    aud_students___teachers: "ተማሪዎች እና መምህራን",
    aud_students___enthusiasts: "ተማሪዎች እና ወዳጆች",
    aud_enthusiasts___nerds: "የሳይንስ ወዳጆች",
    footer_copyright: "የኢትዮጵያ ስፔስ ሳይንስ ሶሳይቲ (ESSS)። መብቱ በህግ የተጠበቀ ነው።",
    login_required: "መግባት ያስፈልጋል",
    login_required_desc: "ይህንን ሞጁል ለመክፈት መግባት ያስፈልጋል። እባክዎን በESSS የጎግል አድራሻዎ ይግቡ።",
    login_btn: "በጎግል ይግቡ",
    logout_btn: "ውጣ",
  }
};
